//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button'
import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar'

export default {
  name: 'ModalMassiveSupervisorAssignment',
  components: { Button, ModalWithTitleBar },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    supervisors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: this.value,
      selected: null,
      innerValue: '',
    }
  },
  watch: {
    value() {
      this.active = this.value
    },
  },
  methods: {
    close() {
      this.active = !this.active
      this.selected = null
      this.innerValue = ''
      this.$emit('close')
      this.$emit('input', this.active)
    },
    massValidateUsers() {
      if (this.selected) {
        this.$emit('mass-validate-users', this.selected)
      }
      this.close()
    },
    selectSupervisor(option) {
      if (option && option.value) {
        this.selected = option
      } else {
        this.selected = null
      }
    },
  },
}
